import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Group, Heading, Level } from '@defa/defa-component-library';
import ReactMarkdown from 'react-markdown';

import { BrandPanel } from '@fractions/brand-panel';
import { AuthLayout, WideOnly } from '@fractions/auth-layout';

import i18n from '@i18n';

export const Welcome: React.FunctionComponent = () => {
    const [query] = useSearchParams();
    const navigate = useNavigate();
    const token = query.get('token');
    const adminId = query.get('adminId');

    return (
        <AuthLayout
            brand={
                <Group>
                    <BrandPanel heading={i18n.t('Welcome.FlowHeader')} />
                    {/* Decoration beside the content on a wide screen; on a
                        phone it would just push the page down. */}
                    <WideOnly>
                        <Heading level={Level.h3}>{i18n.t('Welcome.SubHeader')}</Heading>
                    </WideOnly>
                </Group>
            }
        >
            <Group>
                <Group>
                    <Heading level={Level.h1}>{i18n.t('Welcome.Header')}</Heading>
                </Group>
                <ReactMarkdown>{i18n.t('Welcome.Description')}</ReactMarkdown>
                <Group>
                    <Button
                        text={i18n.t('Welcome.Button')}
                        onClick={() =>
                            navigate({
                                pathname: '/create-account',
                                search: new URLSearchParams({ adminId, token }).toString(),
                            })
                        }
                    />
                </Group>
            </Group>
        </AuthLayout>
    );
};
